import React from 'react';
import AddField from "./AddField";
import PredefinedOptionsAddField from "./PredefinedOptionsAddField";

const AddFieldList = ({
                          index,
                          controlId,
                          properties,
                          status,
                          hiddenPropertyNames,
                          displayOnlyPropertyNames,
                          predefinedOptionProperties,
                          activeEventKey
                      }) => {
    return properties.map((p, propertyIndex) => {
            return hiddenPropertyNames.some(x => x === p.propertyName) ?
                null
                : predefinedOptionProperties.some(x => x.propertyName === p.propertyName) ?
                    <PredefinedOptionsAddField key={propertyIndex}
                                               property={p}
                                               readOnly={status !== "Undecided"}
                                               controlId={`${controlId}.properties[${propertyIndex}]`}
                                               expanded={activeEventKey === index.toString()}
                                               options={predefinedOptionProperties.find(x => x.propertyName === p.propertyName).options}
                    /> 
                    :
                <AddField key={propertyIndex}
                          property={p}
                          readOnly={status !== "Undecided" || displayOnlyPropertyNames.some(x => x === p.propertyName)}
                          controlId={`${controlId}.properties[${propertyIndex}]`}
                          expanded={activeEventKey === index.toString()}
                />
        }
    ).filter(x => x != null).sort((a, b) => {
        return a.props.property.displayOrder - b.props.property.displayOrder
    });
}

export default AddFieldList;